import React from "react";
import type { RouteComponentProps } from "react-router-dom";

import Notification from "../notification";
import PageFooter from "../page_footer";
import PageHeader from "../page_header";
import PatientMenu from "../patient_menu";
import PatientPageBody from "./patient_page_body";
import Tour from "./tour";

export default function PatientPage(props: RouteComponentProps<{ patient_id: string }>) {
  return (
    <div>
      <PageHeader />
      <Tour />
      <div className="container">
        <div className="page-container">
          <PatientMenu />
          <Notification />
          <div className="page-content-wrapper">
            <div className="page-content" style={{ minHeight: 584 }}>
              <PatientPageBody {...props} />
            </div>
          </div>
        </div>
        <PageFooter />
      </div>
    </div>
  );
}
